export default {"src":"/_next/static/media/payment-bitcoin-icon.324628e2.svg","height":20,"width":28};